<template>
  <div class="dateTime">
     <el-date-picker
      v-model="value1"
      @change="changeVale1"
      :picker-options="pickerOptions1"
      type="date"
      placeholder="开始日期">
    </el-date-picker>
    <span>-</span>
    <el-date-picker
      v-model="value2"
      @change="changeVale2"
      :picker-options="pickerOptions2"
      type="date"
      placeholder="结束日期">
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: "DateTime",
  props:{
    value: {},
  },
  data(){
    return{
      value1:'',
      value2:'',
      selectDate:'',
    }
  },
  watch: {
    value(newVal,oldVal){
      this.value1 = newVal[0];
      this.value2 = newVal[1];
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
      pickerOptions2(){
        var that = this
        return{
          disabledDate:(time) => {
              if (that.value1) {
                  var data = new Date(that.value1)
                  var data2 = new Date(that.value1)
                  // var startTime = (data.setFullYear(data.getFullYear() - 3))
                  var endTime = (data2.setFullYear(data2.getFullYear() + 3))
                  // const minTime = startTime
                  const maxTime = endTime
                  return time.getTime() < data || time.getTime() > maxTime || time.getTime() > new Date().getTime()
              }else{
                return false
              }
          }
        }
      },
      pickerOptions1(){
        var that = this
        return{
          disabledDate:(time) => {
              if (that.value2) {
                  var data = new Date(that.value2)
                  var data2 = new Date(that.value2)
                  var startTime = (data.setFullYear(data.getFullYear() - 3))
                  // var endTime = (data2.setFullYear(data2.getFullYear() + 3))
                  const minTime = startTime - 8.64e7
                  // const maxTime = endTime
                  return time.getTime() < minTime ||  time.getTime() > data2.getTime()
              }else{
                return false
              }
          }
        }
      },
  },
  mounted(){},
  methods:{
    changeVale1(){
      if(this.value2){
        var value2 = new Date(new Date(this.value2).setHours(23, 59, 59, 999))
      }
      this.$emit("change", [this.value1,value2]);
    },
    changeVale2(){
      if(this.value2){
        var value2 = new Date(new Date(this.value2).setHours(23, 59, 59, 999))
      }
      this.$emit("change", [this.value1,value2]);
    },
  },
}
</script>

<style lang="less">
.dateTime{
  width: 240px;
  display: flex;
  justify-content: space-between;

  // align-items: center;
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 110px !important;
  }
  .el-date-editor {
    .el-input__inner{
      padding-left:10px;
      width: 110px !important;
    }
    .el-input__prefix{
      display: none;
    }
    .el-range-separator{
      line-height: 30px;
    }
  }
}

</style>